(function() {
  

    /* Prepare Variables
    –––––––––––––––––––––––––––––––––––––––––––––––––– */
    var hideStyleChoice;
    var isWomensBoot;
    var styleChoice;
    var sizingWidthNote;
    var quizGender;
    var quizData;
    var quizSections;
    var quizTabs;
    var currentQuizQuestion;
    var quizAvailableSizes;
    var quizMensSizes;
    var quizWomensSizes;
    var quizSneakerAdjustments;
    var quizDressShoeAdjustments;
    var quizMensAdjustment;
    var quizWomensAdjustment;
  
  
    /* Close Quiz
    –––––––––––––––––––––––––––––––––––––––––––––––––– */
    $('#sizeQuizClose, #size-quiz-overlay').click(function() {
      $('#site-size-quiz').removeClass('active');
      $('#size-quiz-overlay').removeClass('active');
    });


    /* Open Quiz
    –––––––––––––––––––––––––––––––––––––––––––––––––– */
    $(function() {
      if ($("#site-size-quiz-handle").length) {
  
        prepareCloseButton();
        prepareSendMessage();
        prepareCalfWidthSelectBoxes();
        
        $("#site-size-quiz-handle").click(function(e) {
          
          e.preventDefault();
  
          // is womens boot?
          isWomensBoot = $(this).data("size-womens-boot");
        
          if (isWomensBoot) {
            $('#site-size-quiz').addClass('include_calf_widths');
          } else {
            $('#site-size-quiz').addClass('hide_calf_widths');
          }

          // show site overlay
          $('#size-quiz-overlay').addClass('active');

          // open quiz slideout
          $('#site-size-quiz').addClass('active');
  
          // store quiz sections / tabs
          quizSections = $("#site-size-quiz section");
          quizTabs = $("#site-size-quiz .quiz-tabs span");
  
          // record analytics event for size quiz being opened
          if (typeof ga == 'function') {
            ga('send', 'event', 'Size Quiz', 'Opened');
          }
          // get ranges of sizes for the quiz
          quizAvailableSizes = stringToFloatArray($(this).data("size-quiz-available-sizes"));
  
          // hide style choice?
          hideStyleChoice = $(this).data("size-hide-style-choice");
  
          // get width note
          sizingWidthNote = $(this).data("size-width-note");
  
          // store quiz gender & remove unnecessary widths
          quizGender = $(this).data("size-quiz-gender");
          if (quizGender == "mens") {
            $(".womensQuizShoeWidths").remove();
          } else if (quizGender == "womens") {
            $(".mensQuizShoeWidths").remove();
          }
  
          // get adjustments
          quizSneakerAdjustments = stringToFloatArray($(this).data("size-quiz-adjustment-sneakers"));
          quizDressShoeAdjustments = stringToFloatArray($(this).data("size-quiz-adjustment-dress-shoes"));
          quizMensAdjustment = parseFloat($(this).data("size-quiz-adjustment-mens"));
          quizWomensAdjustment = parseFloat($(this).data("size-quiz-adjustment-womens"));
  
          // get mens sizes for the quiz
          quizMensSizes = stringToFloatArray($(this).data("size-quiz-mens-sizes"));
          
          // get womens sizes for the quiz
          quizWomensSizes = stringToFloatArray($(this).data("size-quiz-womens-sizes"));
          
          // if message form has been submitted...
          if ($("#size_quiz_form_submitted").length && !$("#size_quiz_delete_submission_data").length) {
            // if there weren't any errors...
            if (!$(".size_quiz_form_errors").length) {
              // change quiz message title to sent
              $('.quiz-message-title').text('Email sent');
            }
            // populate answers/recommendations
            if (localStorage.getItem("quizAnswers") != null) {
              var savedAnswers = localStorage.getItem("quizAnswers");
              $("#site-size-quiz span[data-quiz-answers]").text(savedAnswers);
              $('#site-size-quiz input[name="contact[Quiz_Answers]"]').val(savedAnswers);
            }
            if (localStorage.getItem("quizRecommendation") != null) {
              var savedRecommendation = localStorage.getItem("quizRecommendation");
              $("#site-size-quiz span[data-quiz-recommendation]").html(savedRecommendation.split(', ').join('<br>'));
              $('#site-size-quiz input[name="contact[Quiz_Recommendation]"]').val(savedRecommendation);
            }
            // unless there are errors, hide form inputs
            if (!$('#size_quiz_form_submitted .errors').length) {
              $('#size_quiz_form_fields').hide();
            }
            // hide all quiz sections
            quizSections.removeClass("quiz-show");
            // hide results and  show contact form
            $('#quiz_show_results').hide(); // hide results
            $('#quiz_send_message').show();
             // show results section
            $("#quiz-results").addClass("quiz-show");
            // we only let people close not go back
            $('#quiz_send_message button[data-quiz-close]').show();
            $('#quiz_send_message button[data-quiz-back]').hide();
             // highlight results tab
            $("#site-size-quiz .quiz-tabs span[data-quiz-tab='results']").addClass("quiz-tab-active");
            // add temporary element to not show if quiz is closed and reopened
            $('#size_quiz_form_submitted').append('<div id="size_quiz_delete_submission_data">');
          } else {
            // otherwise start the quiz!!  
            prepareQuiz();
          }
        });
        
        // if customer clicks custom link to size quiz..
        $(document).on('click', 'a[href="#open-size-quiz"]', function (event) {
            event.preventDefault();
            $('#site-size-quiz-handle').click(); // open the quiz...
            (this).blur(); // unfocus element after scrolling
        });
  
        // if the form has been submitted...
        if ($("#size_quiz_form_submitted").length) {
          // open size quiz
          $("#site-size-quiz-handle").click();
        } else {
          // get URL strings
          var urlParam = function(name) {
            var results = new RegExp('[\?&]'+name+'=([^&#]*)').exec(window.location.search);
            return (results !== null) ? results[1] || 0 : false;
          }
          var action = urlParam('action');
          // if the query string is set to open the size quiz... 
          if (action == 'find-my-size') {
            // open size quiz
            $("#site-size-quiz-handle").click();
          }
        }
      }
    });
  
  
    /* Prepare Array of Floats from string
    –––––––––––––––––––––––––––––––––––––––––––––––––– */
    function stringToFloatArray(stringOfNumbers) {
      var temp = [];
      temp = stringOfNumbers.split(',');
      stringOfNumbers = temp.map(function(size) {
        return parseFloat(size); // convert sizes from strings to floats
      });
      return stringOfNumbers;
    }
  
  
    /* Prepare Quiz
    –––––––––––––––––––––––––––––––––––––––––––––––––– */
    function prepareQuiz() {
      styleChoice = ""; // empty old style choice
      quizData = []; // empty any old quiz data
      // if form success was previously shown...
      if ($("#size_quiz_delete_submission_data").length) {
        // change message title back
        $('.quiz-message-title').text('Send us an email');
        // delete errors / confirmation message
        $("#size_quiz_form_submitted").remove();
      }
      // empty old recommendation and answers
      localStorage.removeItem("quizRecommendation");
      $("#site-size-quiz span[data-quiz-recommendation]").text('');
      $('#site-size-quiz input[name="contact[Quiz_Recommendation]"]').val('');
      localStorage.removeItem("quizAnswers");
      $("#site-size-quiz span[data-quiz-answers]").text('');
      $('#site-size-quiz input[name="contact[Quiz_Answers]"]').val('');
      // empty old form name/email/message data
      $('#site-size-quiz #ContactFormName').val('');
      $('#site-size-quiz #ContactFormEmail').val('');
      $('#site-size-quiz #ContactFormMessage').val('');
      // remove all previous handlers set
      $("#site-size-quiz button").not("#sizeQuizClose, button[data-quiz-close]").off();
      // remove previous selections
      $("#site-size-quiz button").removeClass("selected");
      // disable sizes
      $("#site-size-quiz button.quiz-table").prop('disabled', true);
       // for each question...
      $("section[data-quiz-question]").each(function(){
        quizData.push({ 
          question: $(this).data("quiz-question"), // save the question
          answer: "" // prepare space for answer
        });
      });
      currentQuizQuestion = 1; // set the question to 1
      prepareQuestion(currentQuizQuestion); // prepare the first question
      prepareBackButton(); // prepare back button
    }  
  
  
    /* Questions
    –––––––––––––––––––––––––––––––––––––––––––––––––– */
    function prepareQuestion(number) {
      if(quizData.length >= number) { // if there are still questions...
        
        var index = number -1; // get index to save data to
        var currentSection = $("#site-size-quiz section[data-quiz-question='" + quizData[index].question + "']");
        var currentTab = $("#site-size-quiz .quiz-tabs span[data-quiz-tab='" + quizData[index].question + "']");
  
        quizSections.removeClass("quiz-show"); // hide all other sections
        currentSection.addClass("quiz-show"); // show section for current question
        quizTabs.removeClass("quiz-tab-active"); // hide all other quiz tabs
        currentTab.addClass("quiz-tab-active"); // show tab for current question
        
        // special conditions for particular questions
        if(quizData[index].question == "style-size") {
          prepareStyleQuestion(currentSection);
        } else if(quizData[index].question == "adjustment") {
          prepareAdjustmentQuestion();
        } else if(quizData[index].question == "width") {
          prepareWidthQuestion();
        } else if(quizData[index].question == "calf-width") {
          prepareCalfWidthQuestion(currentSection);
        }
  
        // when answer clicked..
        currentSection.find("button[data-quiz-answer]").click(function() {
          currentSection.find("button[data-quiz-answer]").removeClass("selected");
          $(this).addClass("selected");
          quizData[index].answer = $(this).data("quiz-answer"); // save answer
          currentQuizQuestion++; // iterate question number
          prepareQuestion(currentQuizQuestion); // prepare next question
        });
  
      } else { // if no questions left...
        quizSections.removeClass("quiz-show"); // hide all sections
        prepareResults();
      }
    }
  
  
    /* Style question
    –––––––––––––––––––––––––––––––––––––––––––––––––– */
    function prepareStyleQuestion(currentSection) {
      // initially hide sizes and disable all size answers
      $('.quiz-size-choice').hide();
      currentSection.find("button[data-quiz-answer]").each(function(){
        $(this).prop('disabled', true);
        $(this).removeClass("selected");
      });
      if (hideStyleChoice) {
        // set style and trigger size filters immediately
        $('.quiz-style-choice').hide();
        $('.quiz-size-choice').addClass('quiz_style_choice_hidden')
        styleChoice = "dress-shoe";
        prepareSizeQuestion(currentSection);
      } else {
        // set style and trigger size filters when style is chosen
        currentSection.find("button[data-quiz-style]").click(function() {
          styleChoice = $(this).data("quiz-style");
          prepareSizeQuestion(currentSection);
          currentSection.find("button[data-quiz-style]").removeClass("selected");
          $(this).addClass("selected");
        });
      }
    }
  
  
    /* Size question
    –––––––––––––––––––––––––––––––––––––––––––––––––– */
    function prepareSizeQuestion(currentSection) {
      // show sizes
      $('.quiz-size-choice').show();
      // this enables the sizes that can be selected
      var filter = quizData[0].answer; // save the filter value as the choice of the first question
      if (filter == "mens") {
        filter = quizMensSizes;
      }
      if (filter == "womens") {
        filter = quizWomensSizes;
      }
      // activate/deactivate answer buttons based on filter
      currentSection.find("button[data-quiz-answer]").each(function(){
        // if button size in array of sizes...
        if(($.inArray($(this).data("quiz-answer"), filter)) != -1 ) {
          $(this).removeAttr("disabled"); // enable that button
        } else {
          $(this).removeClass("selected"); // unselect if previously selected
          $(this).prop('disabled', true); // disable that button
        }
      });
    }
  
  
    /* Adjustment question
    –––––––––––––––––––––––––––––––––––––––––––––––––– */
    function prepareAdjustmentQuestion() {
      // set text for size selected in previous question
      var selectedSize = quizData[1].answer;
      $("#site-size-quiz span[data-quiz-selected-size-smaller]").text(selectedSize - 0.5);
      $("#site-size-quiz span[data-quiz-selected-size]").text(selectedSize);
      $("#site-size-quiz span[data-quiz-selected-size-larger]").text(selectedSize + 0.5);
    }
  
    /* Width question
    –––––––––––––––––––––––––––––––––––––––––––––––––– */
    function prepareWidthQuestion() {
      // if a width note exits...
      if (sizingWidthNote != "") {
        $('.size_width_note').text("Note: " + sizingWidthNote);
      } else {
        $('.size_width_note').hide();
      }
    }
  
  
    /* Calf width question
    –––––––––––––––––––––––––––––––––––––––––––––––––– */
    function prepareCalfWidthQuestion(currentSection) {
        if (isWomensBoot) {
          // remove previous selections (e.g. if back button used)
          currentSection.find("button[data-quiz-calf]").removeClass("selected");
          // reset calf width selector labels
          $('.calfWidthSelector span').each(function() {
            var labelText = $(this).data('original-text');
            $(this).text(labelText);
          });
          // collapse any previously opened calf width select options
          $('.calfWidthSelectorOptions').hide();
          // initially hide calf widths and disable answers
          $('.quiz-calf-choice').hide();
          // set show calf widths or continue
          currentSection.find("button[data-quiz-calf]").click(function() {
            var calfChoice = $(this).data("quiz-calf");
            currentSection.find("button[data-quiz-calf]").removeClass("selected");
            $(this).addClass("selected");
            if (calfChoice == "yes") {
              $('.quiz-calf-choice').show();
            } else {
              // find the answer that has 'standard' in the name and click it
              currentSection.find("button[data-quiz-answer]:contains('Standard')").first().click();
            }
          });
        } else {
          currentQuizQuestion++; // iterate question number
          prepareQuestion(currentQuizQuestion); // prepare next question
        }
    }
  
    /* Close Button
    –––––––––––––––––––––––––––––––––––––––––––––––––– */
    function prepareCloseButton() {
      $("#site-size-quiz button[data-quiz-close]").click(function() {
        // close quiz
        $("#sizeQuizClose").trigger("click");
      });
    }
  
  
    /* Back Button
    –––––––––––––––––––––––––––––––––––––––––––––––––– */
    function prepareBackButton() {
      $("#site-size-quiz button[data-quiz-back]").click(function() {
        currentQuizQuestion--; // go back one question
        if(quizData.length == currentQuizQuestion) { // if we would be on the last question
          if (!isWomensBoot) { // if it's not a women's boot
            currentQuizQuestion--; // go back an extra question to skip calf width
          }
        }
        $("#site-size-quiz button").not("#sizeQuizClose, button[data-quiz-close]").off(); // remove all previous handlers set
        prepareQuestion(currentQuizQuestion);
        prepareBackButton();
      });
    }
  
  
    /* Results
    –––––––––––––––––––––––––––––––––––––––––––––––––– */
    function prepareResults() {
  
      console.log(quizData);
  
      // store quiz answers
      var chosenStyle = styleChoice;
      var chosenGender = quizData[0].answer;
      var chosenSize = quizData[1].answer;
      var chosenAdjustment = quizData[2].answer;
      var chosenWidth = quizData[3].answer.split('|');
      var chosenCalfWidth = quizData[4].answer.split('|');
      
      // prepare recommendations
      var recommendedSize = chosenSize;
      var recommendedWidth = chosenWidth[0];
      var recommendedCalfWidth = chosenCalfWidth[0];
      
      // adjust size for gender
      if (chosenGender == "mens") {
        recommendedSize += quizMensAdjustment;
      } else if (chosenGender == "womens") {
        recommendedSize += quizWomensAdjustment;
      }
  
      // adjust size for style
      if (chosenStyle == "sneaker") {
        if (chosenAdjustment == "only") {
          recommendedSize += quizSneakerAdjustments[0];
        } else if (chosenAdjustment == "smaller") {
          recommendedSize += quizSneakerAdjustments[1];
        } else if (chosenAdjustment == "larger") {
          recommendedSize += quizSneakerAdjustments[2];
        }
      } else if (chosenStyle == "dress-shoe") {
        if (chosenAdjustment == "only") {
          recommendedSize += quizDressShoeAdjustments[0];
        } else if (chosenAdjustment == "smaller") {
          recommendedSize += quizDressShoeAdjustments[1];
        } else if (chosenAdjustment == "larger") {
          recommendedSize += quizDressShoeAdjustments[2];
        }
      }
    
      // set recommendation text
      var quizRecommendation = 'Size: ' + recommendedSize + ', Width: ' + recommendedWidth;
      if (isWomensBoot) {
        quizRecommendation += ', Calf Width: ' + recommendedCalfWidth;
      }
      
      // fill in recommendation
      $("#site-size-quiz span[data-quiz-recommendation]").html(quizRecommendation.split(', ').join('<br>'));
      
      // add recommendation to hidden form field
      $('#site-size-quiz input[name="contact[Quiz_Recommendation]"]').val(quizRecommendation);
      
      // save to localstorage
      localStorage.setItem("quizRecommendation", quizRecommendation);
      
      // if recommended size in available sizes...
      if(($.inArray(recommendedSize, quizAvailableSizes)) != -1 ) {
        // yes = recommended!
        $(".quiz-available").show();
        $(".quiz-unavailable").hide();
        prepareConfirmButton(recommendedSize, recommendedWidth, recommendedCalfWidth);
      } else {
        // no = unavailable!
        $(".quiz-unavailable").show();
        $(".quiz-available").hide();
      }
  
      // record analytics event for completion with the recommended size
      if (typeof ga == 'function') {
        ga('send', 'event', 'Size Quiz', 'Completed', 'Size: '+recommendedSize+' Width: '+recommendedWidth);
        if (isWomensBoot) {
          ga('send', 'event', 'Size Quiz', 'Completed', 'Size: '+recommendedSize+', Width: '+recommendedWidth+', Calf Width: '+recommendedCalfWidth);
        } else {
          ga('send', 'event', 'Size Quiz', 'Completed', 'Size: '+recommendedSize+', Width: '+recommendedWidth);
        }
      }
  
      // prepare restart button
      prepareRestartButton();
      
      // prepare results section
      $('#quiz_show_results').show(); // show results
      $('#quiz_send_message').hide(); // hide contact form    
  
      // show results section
      $("#quiz-results").addClass("quiz-show");
      
      // show results tab
      quizTabs.removeClass("quiz-tab-active"); // hide all other quiz tabs
      var currentTab = $("#site-size-quiz .quiz-tabs span[data-quiz-tab='results']");
      currentTab.addClass("quiz-tab-active"); // show tab for current question
  
      // prepare animation
      var animationImage = $('.quiz-animation');
      animationImage.hide();
      animationImage.attr('src', '');
      animationImage.attr('src', animationImage.data('src'));
      animationImage.show();
  
    }
  
  
    /* Restart Button
    –––––––––––––––––––––––––––––––––––––––––––––––––– */
    function prepareRestartButton() {
      $("#quiz-restart").click(function(e) {
        // empty old recommendation and answers
        $("#site-size-quiz span[data-quiz-recommendation]").text('');
        $("#site-size-quiz span[data-quiz-answers]").text('');
        // record analytics event for size quiz being opened
        if (typeof ga == 'function') {
          ga('send', 'event', 'Size Quiz', 'Restarted');
        }
        prepareQuiz();
      });
    }
    
  
    /* Confirm Button
    –––––––––––––––––––––––––––––––––––––––––––––––––– */
    function prepareConfirmButton(size, width, calfWidth) {
      $("#quiz-confirm").click(function(e) {
        // Select options on product page
        $("#left-foot-size, #right-foot-size").val(size);
        $("#left-foot-width, #right-foot-width").val(width);
        if (isWomensBoot) {
          $("#calf-width").val(calfWidth);
        }
        // close size quiz
        $("#sizeQuizClose").trigger("click");
      });
    }
    
    
    /* Send Message
    –––––––––––––––––––––––––––––––––––––––––––––––––– */
    function prepareAnswers() {
      // store quiz answers
      var chosenStyle = styleChoice;
      var chosenGender = quizData[0].answer;
      var chosenSize = quizData[1].answer;
      var chosenAdjustment = quizData[2].answer;
      var chosenWidth = quizData[3].answer.split('|');
      var chosenCalfWidth = quizData[4].answer.split('|');
      // prepare to store answers
      var quizAnswers = '';
      // add gender to answers
      if (chosenGender != '') {
        quizAnswers += "Sizing: ";
        if (chosenGender == 'mens') {
          quizAnswers += "Men's";
        } else {
          quizAnswers += "Women's";
        }
      }
      // add style to answers
      if (!hideStyleChoice && chosenStyle != '') {
        quizAnswers += ", Style: ";
        if (chosenStyle == "sneaker") {
          quizAnswers += "Sneakers";
        } else {
          quizAnswers += "Dress Shoes";
        }
      }
      // add size to answers
      if (chosenSize != '') {
        quizAnswers += ", Size: " + chosenSize;
      }
      // add size adjustment to answers
      if (chosenAdjustment != '') {
        var adjustedSize = chosenSize;
        if (chosenAdjustment == "only") {
          quizAnswers += ", Adjustment: Always size " + adjustedSize;
        } else if (chosenAdjustment == "smaller") {
          adjustedSize += -0.5;
          quizAnswers += ", Adjustment: Sometimes size " + adjustedSize;
        } else if (chosenAdjustment == "larger") {
          adjustedSize += 0.5;
          quizAnswers += ", Adjustment: Sometimes size " + adjustedSize;
        }        
      }
      // add width to answers
      if (chosenWidth[1] != undefined) {
        quizAnswers += ", Width: " + chosenWidth[1];
      }
      // add calf width to answers
      if (chosenCalfWidth[1] != undefined) {
        quizAnswers += ", Calf Width: " + chosenCalfWidth[1];
      }
      // fill in answers
      $("#site-size-quiz span[data-quiz-answers]").text(quizAnswers);
      // add answers to hidden form field
      $('#site-size-quiz input[name="contact[Quiz_Answers]"]').val(quizAnswers);
      // save to localstorage
      localStorage.setItem("quizAnswers", quizAnswers);
    }
    
    
    /* Send Message
    –––––––––––––––––––––––––––––––––––––––––––––––––– */
    function prepareSendMessage() {
      $("#site-size-quiz a[data-quiz-send-message]").click(function(e) {
        
        e.preventDefault();
        
        currentQuizQuestion++; // increment question so if "back" is used it will go to the correct question
        
        // fill in answers
        prepareAnswers();  
        
        // prepare results section
        quizSections.removeClass("quiz-show"); // hide all quiz sections
        $('#quiz_show_results').hide(); // hide results
        $('#quiz_send_message').show(); // show contact form
        $('#size_quiz_form_fields').show(); // show form fields
        $('#quiz_send_message button[data-quiz-close]').hide(); // hide close button (this is only shown if already submitted form)
        $('#quiz_send_message button[data-quiz-back]').show(); // show back button
        $("#quiz-results").addClass("quiz-show"); // show results section
        
      });
    }
    
    /* Calf Width Select Boxes
    –––––––––––––––––––––––––––––––––––––––––––––––––– */
    function prepareCalfWidthSelectBoxes() {
      $('.calfWidthSelector span').click(function() {
        // Close / Reset other select boxes
        $('.calfWidthSelector span').not(this).each(function(){
          $(this).next('.calfWidthSelectorOptions').hide();
          $(this).text($(this).data('original-text'));
        })
        var selectText = 'Select an option:';
        var labelText = $(this).data('original-text');
        var selectOptions = $(this).next('.calfWidthSelectorOptions');
        // Open this select box
        $(selectOptions).slideToggle();
        if ($(this).text() != selectText) {
          $(this).text(selectText);
        } else {
          $(this).text(labelText);
        }
      });
    }  
  
})()
  